import React, {useState} from 'react';
import PropTypes from 'prop-types';
import classnames from "classnames";
import moment from "moment";
import ProgressiveImage from "react-progressive-image";
import assets from "../../../../../util/assets";
import {getStatus} from "../../../../../util/utility";
import "./index.css";
import CommonImageCard from "../../../../CommonImageCard";
import ImageButton from "../../../../ImageButton";
import share from "../../../../../util/share";
import constants from "../../../../../util/constants";
import {Popover, PopoverBody} from 'reactstrap';
import DropdownItem from "../../../broadcaster/library/dropdown-item/DropdownItem";

HomeCardComponent.propTypes = {
    isDetailPage: PropTypes.bool,
    isDetailModal: PropTypes.bool,
    content: PropTypes.object.isRequired,
    openDetail: PropTypes.func.isRequired,
    selectCard: PropTypes.func,
    openBroadcasterProfile: PropTypes.func.isRequired
};

HomeCardComponent.defaultProps = {
    isDetailPage: false,
    showBroadcasterSection: true,
    isDetailModal: false,
    perVideoPaid: false,
    ppmPaid: false,
    isCheckBox: false,
    hideTitle: false,
    containerClassName: "",
    imgLoadingContainer: "",
    imgContainerClassName: "",
    selectedItems: [],
    clickedOnLike: () => {
    },
    showRequestTipModal: () => {
        console.log("showRequestTipModal")
    },
    pageName: "HOME",
    isBroadcastersOwnPage: false,
    editVideo:()=>{

    },
    deleteVideo:()=>{

    },
    editGallery:()=>{

    },
    deleteGallery:()=>{

    }
}

const setVideoFormattedPrice = (props) => {
    if (props.content && props.content.hasOwnProperty("pricing")) {
        return props.content.pricing.price !== 0 ? `£ ${(props.content.pricing.price / 100).toFixed(2)}` : "Free"
    } else {
        return "Free";
    }
}

const setVideoFormattedPPM = (props) => {
    if (props.content && props.content.hasOwnProperty("pricing")) {
        return props.content.pricing.ppm !== 0 ? `£ ${(props.content.pricing.ppm / 100).toFixed(2)}` : "Free"
    } else {
        return "Free";
    }
}

const isVideo = (props) => {
    if (props.content.hasOwnProperty("type")) {
        if (props.content.type === "picture") {
            return false;
        } else if (props.content.type === "gallery") {
            return props.content.hasOwnProperty("total_pictures") && props.content.total_pictures === 0;
        }
    } else if (props.content.hasOwnProperty("pictures") && props.content.hasOwnProperty("videos")) {
        const pictures = props.content.pictures;
        const videos = props.content.videos;

        if (pictures && Array.isArray(pictures) && pictures.length > 0) {
            return false;
        }
    }

    return true;
}

const getType = (props)=>{
    if (props.content.hasOwnProperty("type")) {
        if (props.content.type === "picture") {
            return 'Picture';
        } else if (props.content.type === "gallery") {
            return 'Gallery';
        }
    } else if (props.content.hasOwnProperty("pictures") && props.content.hasOwnProperty("videos")) {
        const pictures = props.content.pictures;
        const videos = props.content.videos;

        if (pictures && Array.isArray(pictures) && pictures.length > 0) {
            return 'Gallery';
        }
    }

    return 'Video';
}

function HomeCardComponent(props) {

    const shareList = share.getListArray(window.location.href);
    const [popoverOpen, setPopoverOpen] = useState(false);
    const toggle = () => setPopoverOpen(!popoverOpen);

    let container = classnames("home-container-list-item-container", {
        "home-container-list-item-container-auto": props.isDetailModal || !props.showBroadcasterSection
    })

    if(props.containerClassName.length > 0){
        container = classnames(props.containerClassName);
    }

    const videoFormattedPrice = setVideoFormattedPrice(props)
    const videoFormattedPPM = setVideoFormattedPPM(props)

    return (
        <div className={container}>

            {
                !props.isDetailPage &&
                <CommonImageCard
                    clickedOnLike={props.clickedOnLike}
                    openBroadcasterProfile={props.openBroadcasterProfile}
                    hideTitle={props.hideTitle}
                    containerClassName={props.containerClassName}
                    imgLoadingContainer={props.imgLoadingContainer}
                    imgContainerClassName={props.imgContainerClassName}
                    showBroadcasterSection={props.showBroadcasterSection}
                    selectCard={props.selectCard}
                    openDetail={props.openDetail}
                    content={props.content}
                    isCheckBox={props.isCheckBox}
                    selectedItems={props.selectedItems}
                />
            }


            <div className="home-container-list-item">
                {
                    props.isDetailPage ?
                        <div className="display-flex-space-between" style={{position:'relative'}}>
                            <div>
                                <div className="home-container-list-item-title-large">
                                    {props.content.title}
                                </div>
                                {

                                    <div className="display-flex-justify-content-flex-start-align-items-center">
                                        <div>
                                            {props.perVideoPaid &&
                                            <img src={assets.clipstore.home.purchased} alt={"purchased"}/>}
                                            <span
                                                className="home-container-list-item-video-pricing">{`${getType(props)}: ${videoFormattedPrice}`}</span>
                                        </div>
                                        {
                                            isVideo(props) &&
                                            <div style={{paddingLeft: 16}}>
                                                {props.ppmPaid &&
                                                <img src={assets.clipstore.home.purchased} alt={"purchased"}/>}
                                                <span
                                                    className="home-container-list-item-video-pricing">{`PPM: ${videoFormattedPPM}`}</span>
                                            </div>
                                        }
                                    </div>
                                }

                            </div>
                            <div className="home-container-list-item-image-btn-container">
                                <ImageButton
                                    image={{
                                        src: assets.comments.like_with_coin_black,
                                        height: 30
                                    }}
                                    text={"Like"}
                                    action={props.showRequestTipModal}/>


                                <div className={"popover__wrapper"}>
                                    <ImageButton
                                        image={{
                                            src: assets.comments.share_black,
                                            style: {marginBottom: 5}
                                        }}
                                        text={"Share"}
                                        action={() => {
                                            console.log("Share")
                                        }}/>
                                    <div className="popover_share_content">
                                        <ul className="popover_menucontent" aria-labelledby="myDropdown">
                                            {
                                                shareList &&
                                                shareList.map((shareData, index) => {
                                                    return (
                                                        <li style={{display: "inline-block"}}
                                                            key={`share-key-${index}`}>
                                                            <a>{shareData}</a>
                                                        </li>
                                                    )
                                                })
                                            }
                                        </ul>
                                    </div>
                                </div>

                                {/*<ImageButton*/}
                                {/*    image={{*/}
                                {/*        src: assets.clipstore.home.home_more,*/}
                                {/*        style: {marginBottom: 5}*/}
                                {/*    }}*/}
                                {/*    text={"More"}*/}
                                {/*    action={() => {*/}
                                {/*        console.log("More")*/}
                                {/*    }}/>*/}
                            </div>
                        </div>
                        :
                        (
                            !props.hideTitle &&
                            <div className="display-flex-space-between" style={{position: 'relative'}}>
                                <div className="home-container-list-item-title" onClick={() => {
                                    props.openDetail(props.content, "detail")
                                }}>
                                    {props.content.title}
                                </div>
                                {
                                    props.pageName === constants.BROADCASTER_PROFILE && props.isBroadcastersOwnPage &&
                                    <img className="home-container-list-item-more"
                                         src={popoverOpen ? assets.clipstore.home.home_more_selected : assets.clipstore.home.home_more}
                                         id={`home-card-component-more-${props.content.id}`}/>
                                }
                            </div>

                        )
                }

            </div>

            {
                props.isDetailPage &&
                <div className="divider-copy"/>
            }
            {
                props.showBroadcasterSection &&
                <div style={{height: 44}}>
                    <div className="home-container-user-section" onClick={() => {
                        props.openBroadcasterProfile(props.content)
                    }}>
                        <ProgressiveImage
                            delay={1000}
                            src={props.content.broadcaster.profile_pic}
                            placeholder="placeholder"
                        >
                            {(src, loading) => {
                                return loading ? (
                                        <img alt="broadcaster profile picture"
                                             className="home-container-user-section-profile-pic"
                                             src={assets.user_placeholder}/>
                                    ) :
                                    (
                                        <div className="home-container-user-section-profile-pic"
                                             style={{backgroundImage: "url('" + props.content.broadcaster.profile_pic + "')"}}>

                                            <img
                                                src={props.content.broadcaster.is_verified === 1 ? assets.clipstore.home.broadcaster_verified : assets.clipstore.home.broadcaster_unverified}
                                                alt="verified broadcaster"/>
                                        </div>
                                    )

                            }}
                        </ProgressiveImage>
                        <div>
                            <div style={{textAlign: 'left'}}>
                            <span
                                className="home-container-user-section-username">{props.content.broadcaster.username}</span>
                                <img src={getStatus(props.content.broadcaster.status)}
                                     alt="broadcaster status"/>
                            </div>
                            <div className="home-container-user-section-view-container">
                                <span className="home-container-user-section-views">{props.content.views} views</span>
                                <div className="bullets"/>
                                <span
                                    className="home-container-user-section-time">{moment(props.content.updated_at).local().fromNow()}</span>
                            </div>
                        </div>
                    </div>
                </div>
            }

            {
                props.pageName === constants.BROADCASTER_PROFILE && props.isBroadcastersOwnPage &&
                <Popover placement="bottom" isOpen={popoverOpen} target={`home-card-component-more-${props.content.id}`}
                         toggle={toggle}>
                    <PopoverBody className="my-library-actions-pop-over-body">
                        <div>
                            <DropdownItem
                                isFetching={false}
                                onClick={() => {
                                    console.log("editing",props.content)
                                    toggle()
                                    if(props.content.type === "gallery"){
                                        props.editGallery(props.content.id)
                                    }else{
                                        props.editVideo(props.content.id)
                                    }
                                }}
                                icon={assets.clipstore.more.editVideo}
                                text={"Edit"}
                            />

                            <DropdownItem
                                isFetching={false}
                                onClick={() => {
                                    console.log("deleting")
                                    toggle()
                                    if(props.content.type === "gallery"){
                                        props.deleteGallery(props.content.id)
                                    }else{
                                        props.deleteVideo(props.content.id)
                                    }
                                }}
                                icon={assets.clipstore.more.deleteVideo}
                                text={"Delete"}
                            />

                        </div>
                    </PopoverBody>
                </Popover>
            }

            {/*<Popover placement="bottom" isOpen={popoverOpen} target={`home-card-component-more-${props.content.id}`}*/}
            {/*         toggle={toggle}>*/}
            {/*    <PopoverBody className="my-library-actions-pop-over-body">*/}
            {/*        <div>*/}
            {/*            <DropdownItem*/}
            {/*                isFetching={false}*/}
            {/*                onClick={() => {*/}
            {/*                    toggle();*/}
            {/*                }}*/}
            {/*                icon={assets.clipstore.home.more.more_view_profile}*/}
            {/*                text={"View Profile"}*/}
            {/*            />*/}

            {/*            <DropdownItem*/}
            {/*                isFetching={false}*/}
            {/*                onClick={() => {*/}
            {/*                    toggle();*/}
            {/*                }}*/}
            {/*                icon={assets.clipstore.home.more.more_fav}*/}
            {/*                text={"Favourite"}*/}
            {/*            />*/}

            {/*            {*/}
            {/*                props.content.is_following ?*/}
            {/*                    <DropdownItem*/}
            {/*                        isFetching={false}*/}
            {/*                        onClick={() => {*/}
            {/*                            toggle();*/}
            {/*                        }}*/}
            {/*                        icon={assets.clipstore.home.more.more_unfollow}*/}
            {/*                        text={"Unfollow"}*/}
            {/*                    />*/}
            {/*                    :*/}
            {/*                    <DropdownItem*/}
            {/*                        isFetching={false}*/}
            {/*                        onClick={() => {*/}
            {/*                            toggle();*/}
            {/*                        }}*/}
            {/*                        icon={assets.clipstore.home.more.more_follow}*/}
            {/*                        text={"Follow"}*/}
            {/*                    />*/}
            {/*            }*/}

            {/*            <DropdownItem*/}
            {/*                isFetching={false}*/}
            {/*                onClick={() => {*/}
            {/*                    toggle();*/}
            {/*                }}*/}
            {/*                icon={assets.clipstore.home.more.more_share}*/}
            {/*                text={"Share"}*/}
            {/*            />*/}

            {/*            <DropdownItem*/}
            {/*                isFetching={false}*/}
            {/*                onClick={() => {*/}
            {/*                    toggle();*/}
            {/*                }}*/}
            {/*                icon={assets.clipstore.home.more.more_report}*/}
            {/*                text={"Report"}*/}
            {/*            />*/}

            {/*        </div>*/}
            {/*    </PopoverBody>*/}
            {/*</Popover>*/}

        </div>
    );
}

export default HomeCardComponent;